import { createSlice } from "@reduxjs/toolkit";

const savedUser = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const communityauthSlice = createSlice({
  name: "communityauth",
  initialState: {
    isAuth: !!savedUser,
    userInfo: savedUser || null,
  },

  reducers: {
    loginSuccess: (state, action) => {
      state.isAuth = true;
      state.userInfo = action.payload;

      // persist
      localStorage.setItem("userInfo", JSON.stringify(action.payload));
    },

    logout: (state) => {
      state.isAuth = false;
      state.userInfo = null;

      localStorage.removeItem("userInfo");
    },
  },
});

export const { loginSuccess, logout } = communityauthSlice.actions;
export default communityauthSlice.reducer;
